import { combineReducers } from "redux"
import {
  groupTransactionsAggregLoadingStarted,
  loadedGroupTransactionAggreg,
  groupTransactionAggregLoadingError,
} from "./getGroupTransactionsAggregate"
import { currentTransactionContext } from "./transactionContext"
import {
  gettingGroupMeetings,
  groupMeetings,
  groupmeetingsLoadingError,
} from "./getAllGroupMeetings"
import {
  memberBalanceLoaded,
  memberBalanceLoadStarted,
  memberBalanceLoadError,
} from "./getMemberBalance"
import { balance, balanceError, vslaBalanceLoading } from "./getVslaBalance"
import {
  memberTransactionsAggregLoadingStarted,
  loadedMemberTransactionAggreg,
  memberTransactionAggregLoadingError,
} from "./getMemberAggregates"
import { vslaIsLoading, vsla, vslaHasErrored } from "./vslaDataReducer"
import { creatingFund, vslaFund, createFundError } from "./createFundAccounts"
import {
  isCreatingVsla,
  vslaCreated,
  createVslaError,
  groupError,
  projects,
} from "./createVsla"
import { isLoading, vlsasLoadingError } from "./getVslas"
import {
  isCreatingVslaMember,
  vslaMember,
  groupMember,
} from "./createMember"
import {
  loadedvslaMembers,
  vlsaMembersLoadingStarted,
  vlsaMembersLoadingError,
  memberToEdit,
} from "./getVslaMembers"
import {
  meetingTransactionsLoadingStarted,
  meetingTransactionLoadingError,
} from "./getTransactions"
import {
  loadedGroupItem,
  groupItemLoadingStarted,
  groupItemLoadingError,
} from "./getGroupItem"
import {
  loadedUserVsla,
  UserVlsaLoadingStarted,
  userVlsaLoadingError,
} from "./getUserVsla"
import {
  isUpdatingVsla,
  groupUpdated,
  vslaUpdated,
  groupUpdateError,
  updateVslaError,
} from "./updateVslaAndGroup"
import {
  isCreatingUser,
  createdUser,
  createUserDetails,
  createUserError,
  loadingToggleState,
} from "./signUp"
import {
  geoDataError,
  geoDataRequestStartedLat,
  geoDataRequestStartedLong,
  geoDataReturnedLat,
  geoDataReturnedLong,
} from "./geoData"
import {
  createMeetingError,
  isCreatingMeeting,
} from "./createMeeting"
import {
  currentOngoingMeeting,
  meetingLoadingError,
  gettingOngoingMeeting,
} from "./getMeeting"
import { loadedMember, memberLoadingError, memberLoadingStarted } from "./getMember"
import {
  loadedMemberHOL,
  memberLoadingStartedHOL,
  memberLoadingHOLError,
} from "./getMemberInfo"
import {
  isUpdatingMember,
  memberUpdatedHOL,
  memberUpdatedBC,
  updateMemberErrorHOL,
  updateMemberErrorBC,
} from "./updateMemberInfo"

import { account, accountV2 } from "./transactions"

import { dismissInstallBanner } from "./dismissInstallBanner"

import { pendingTransactions, searchUsers } from "./members"
import currentPage, { previousPage } from "./navigation"

import { learningData, selectedLearningContent } from "./learning"

import {
  meetingTransactions,
  previousMeetingsTransactions,
  offlineMeetings,
} from "./meeting"
import user from "./user"
import { isConnected, uploadStatus } from "./networkStatus"

import {
  membersTocashout,
  membersWithLoans,
  loadingCashoutData,
  cashoutStarted,
} from "./cashout"

import { cycles } from "./cycles"
import { countries, locationTransport, locations } from "./location"
import { group } from "./base/group"
import { meeting } from "./base/meeting"
import queue from "./queue"

const reducers = combineReducers({
  queue,
  learningData,
  selectedLearningContent,
  cycles,
  uploadStatus,
  offlineMeetings,
  isConnected,
  user,
  previousMeetingsTransactions,
  meetingTransactions,
  currentPage,
  account,
  accountV2,
  pendingTransactions,
  dismissInstallBanner,
  groupTransactionsAggregLoadingStarted,
  loadedGroupTransactionAggreg,
  groupTransactionAggregLoadingError,
  currentTransactionContext,
  memberBalanceLoaded,
  memberBalanceLoadStarted,
  memberBalanceLoadError,
  memberTransactionsAggregLoadingStarted,
  loadedMemberTransactionAggreg,
  memberTransactionAggregLoadingError,
  creatingFund,
  vslaFund,
  createFundError,
  balance,
  balanceError,
  vslaBalanceLoading,
  vslaIsLoading,
  vsla,
  vslaHasErrored,
  vslaCreated,
  isCreatingVsla,
  group,
  createVslaError,
  groupError,
  vlsasLoadingError,
  isLoading,
  isCreatingVslaMember,
  vslaMember,
  groupMember,
  loadedvslaMembers,
  memberToEdit,
  vlsaMembersLoadingStarted,
  vlsaMembersLoadingError,
  loadedGroupItem,
  groupItemLoadingStarted,
  groupItemLoadingError,
  meetingTransactionsLoadingStarted,
  meetingTransactionLoadingError,
  loadedUserVsla,
  UserVlsaLoadingStarted,
  userVlsaLoadingError,
  isUpdatingVsla,
  groupUpdated,
  vslaUpdated,
  groupUpdateError,
  updateVslaError,
  isCreatingUser,
  createdUser,
  createUserDetails,
  createUserError,
  loadingToggleState,
  geoDataError,
  geoDataRequestStartedLat,
  geoDataRequestStartedLong,
  geoDataReturnedLat,
  geoDataReturnedLong,
  createMeetingError,
  isCreatingMeeting,
  currentOngoingMeeting,
  meetingLoadingError,
  gettingOngoingMeeting,
  loadedMember,
  memberLoadingError,
  memberLoadingStarted,
  loadedMemberHOL,
  memberLoadingStartedHOL,
  memberLoadingHOLError,
  isUpdatingMember,
  memberUpdatedHOL,
  memberUpdatedBC,
  updateMemberErrorHOL,
  updateMemberErrorBC,
  gettingGroupMeetings,
  groupMeetings,
  groupmeetingsLoadingError,
  membersWithLoans,
  membersTocashout,
  loadingCashoutData,
  cashoutStarted,
  previousPage,
  projects,
  locationTransport,
  locations,
  countries,
  meeting,
  searchUsers
})

export default (state, action) => {
  if (action.type === "RESET") {
    state = undefined
  }
  return reducers(state, action)
}
